import React, { useState } from "react";
import propTypes from "prop-types";

const list = [{ name: "loading...", id: 0 }];

const LabelInput = ({
  onChange,
  label,
  name,
  value = "",
  data = list,
  required = false,
  errorMsg = null,
  isError = true,
  disabled = false,
  corpClass = null,
  isChecked =false
}) => {
  const [isValue, setIsValue] = useState(value.length ? value : "");
  const [listData, setListData] = useState(data);
  const handleCheckboxChange = (checked) => {
    setIsValue(checked);
    if (onChange) onChange(checked);
  };
  return (
    <div className="form-check">
     <input 
      className="form-check-input" 
      type="checkbox" 
      value=""
      checked={isChecked}
      onChange={(e) => handleCheckboxChange(e.target.checked)}
     /> 
     <label className={`form-check-label ${corpClass}`} htmlFor="flexCheckChecked">{label}</label>
    </div>
  );
};

LabelInput.propTypes = {
  type: propTypes.oneOfType([propTypes.object, propTypes.string]),
  inputValue: propTypes.oneOfType([
    propTypes.object,
    propTypes.string,
    propTypes.number,
  ]),
  handleChange: propTypes.func,
  label: propTypes.oneOfType([propTypes.string, propTypes.object]),
  checked: propTypes.oneOfType([propTypes.string, propTypes.object]),
  errorMsg: propTypes.oneOfType([propTypes.string, propTypes.object]),
  name: propTypes.oneOfType([propTypes.string, propTypes.object]),
};

export default LabelInput;
